@if (showReviews) {
  <div class="slide-wrap">
    <div class="slideshow-header">
      <p>What consumers are saying:</p>
    </div>
    <div class="slideshow">
      <!-- <ul *ngIf="false" class="slide-nav">
      <li id="prev-slide" (click)="prevSlide()"><i class="fa fa-circle-chevron-left"></i></li>
      <li id="next-slide" (click)="nextSlide()"><i class="fa fa-circle-chevron-right"></i></li>
    </ul> -->
    <app-slide-entry [reviews]="reviews" [mobile]="mobile"></app-slide-entry>
    <!-- <div *ngIf="!mobile" class="reviews-description">
    <p>Rated as <span class="tag recommended">Recommended</span> based on consumers reviews.</p>
    <p>Showing our best reviews from TrustPilot.</p>
  </div>
  <div *ngIf="mobile" class="reviews-description">
    <p>Rated as <span class="tag recommended">Recommended</span> based on consumers reviews. Showing our best reviews from TrustPilot.</p>
  </div> -->
</div>
</div>
}